import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// constants
import { BFR } from '../../lib/Constants';

// components
import Info from '../../components/Info';
import Btn from '../../components/Btn';

// helpers
import { i18n, fixLocalePath } from '../../lib/Utils';

class ComingSoon extends Component {
  constructor(props) {
    super(props);

    this.openWindow = this.openWindow.bind(this);
  }

  openWindow() {
    const { locale } = this.props;

    // locale is a temporary fix until SDL connector is working
    const localeStr = fixLocalePath(locale);
    window.open(`${localeStr}/findus`);
  }

  render() {
    // eslint-disable-next-line object-curly-newline
    const { outOfRangeLabel, CTA, noChargers, modelCode } = this.props;
    // eslint-disable-next-line operator-linebreak
    const showSuperchargersLink =
      CTA.plannedChargers.label != null && CTA.plannedChargers.label !== '';

    if (!noChargers && modelCode === BFR) {
      return <Info>{i18n(outOfRangeLabel)}</Info>;
    }

    if (noChargers) {
      return (
        <Info>
          {i18n(outOfRangeLabel)}
          {showSuperchargersLink && (
            <Btn
              styles="route__cta route__cta--info"
              handleClick={this.openWindow}
            >
              {CTA.plannedChargers.label}
            </Btn>
          )}
        </Info>
      );
    }

    return null;
  }
}

ComingSoon.propTypes = {
  outOfRangeLabel: PropTypes.string.isRequired, // Warning message to user when trip is not yet possible
  CTA: PropTypes.shape({ plannedChargers: PropTypes.object.isRequired })
    .isRequired, // All properties for vehicle specific primary and secondary CTA's
  noChargers: PropTypes.bool.isRequired, // True when there are not enough superchargers for the trip
  locale: PropTypes.string.isRequired, // Current user locale "en_US"
  modelCode: PropTypes.string.isRequired, // Selected vehicle model code
};

ComingSoon.defaultProps = {};

const mapStateToProps = state => ({
  outOfRangeLabel: state.RouteSummary.outOfRangeLabel,
  CTA: state.RouteSummary.CTA,
  noChargers: state.Superchargers.noChargers,
  locale: state.App.locale,
  modelCode: state.Vehicle.modelCode,
});

export default connect(
  mapStateToProps,
  null,
)(ComingSoon);
